import { RootState } from "@/models/RootState.type";
import { AppDispatch } from "@/models/AppDispatch.type";
import { createListenerMiddleware } from "@reduxjs/toolkit";
import {
  updateAssignmentMutationLoadingState,
  updateCRUDAssignmentsQueue,
} from "../slices";
import { AsyncLoadingState } from "@/features/dashboard/enums";
import { shiftQueueAssignmentExec } from "./crudAssignmentsQueueListener";

export const addUpdateCRUDAssignmentsQueueListenerMiddleware = (
  listenerMiddleware: ReturnType<typeof createListenerMiddleware>
) => {
  listenerMiddleware.startListening.withTypes<RootState, AppDispatch>()({
    actionCreator: updateCRUDAssignmentsQueue,
    effect: async (action: any, listenerApi: any) => {
      try {
        const { weeklyPlan, reports, userData } =
          listenerApi.getState() as RootState;
        if (
          weeklyPlan.data?.crudAssignmentQueue &&
          weeklyPlan.data?.crudAssignmentQueue.length &&
          weeklyPlan.mutateAssignmentsLoading !== AsyncLoadingState.LOADING
        ) {
          listenerApi.dispatch(
            updateAssignmentMutationLoadingState(AsyncLoadingState.LOADING)
          );
          // Start the assignment mutation queue
          shiftQueueAssignmentExec(listenerApi, weeklyPlan, reports, userData);
        }
      } catch (error) {
        console.error("Error aggregating lessons from assignments:", error);
        // TODO dispatch a fetch retry action maybe?
        // listenerApi.dispatch(setLoading(AsyncLoadingState.ERROR));
      }
    },
  });
};
